// PDA1061_R01 재고조회 DTO

export interface PDA1061_R01Dto {
  // 품목 정보 (응답)
  itemCd: string | null;
  itemNm: string | null;
  itemSpec: string | null;
  modelNo: string | null;
  unit?: string | null;

  // 재고 정보 (응답)
  logicCenter: string | null;
  logicCenternm: string | null;
  warehouseCd: string | null;
  warehouseNm: string | null;
  itemStatus: string | null;
  stockQty: number | null;
  reservQty: number | null;
  availableQty: number | null;

  // 위치 (테이블: 창고, 위치, 등급, 수량)
  /** 위치(로케이션) - itemCd 기준 locationCd 값 */
  locationCd?: string | null;
  locationNm?: string | null;

  // 백엔드 신규 응답 필드 (resultItemCd 등)
  resultItemCd?: string | null;
  resultLogicCenter?: string | null;
  resultWarehouseCd?: string | null;
}

export interface PDA1061_R01SearchParams {
  /** 스캔값 (품목코드/바코드) */
  scanValue?: string;

  /** @deprecated scanValue 사용 권장 */
  itemCd?: string;
  /** @deprecated 백엔드에서 더 이상 사용 안 함 */
  lotNo?: string;
  /** @deprecated 백엔드에서 더 이상 사용 안 함 */
  barcode?: string;

  logicCenter?: string;
  warehouseCd?: string;
  itemStatus?: string;

  itemNm?: string;
  itemSpec?: string;
  modelNo?: string;
}

/** 상단 Info 패널 표시용 (API 응답 일부 필드만) */
export interface PDA1061_R01DisplayInfo {
  itemCd: string;
  itemNm: string;
  itemSpec: string;
  modelNo: string;
  unit: string;
  itemStatus: string;
  warehouseNm: string;
  locationCd: string;
  stockQty: number | null;
}

export const defaultPDA1061_R01DisplayInfo: PDA1061_R01DisplayInfo = {
  itemCd: "",
  itemNm: "",
  itemSpec: "",
  modelNo: "",
  unit: "",
  itemStatus: "",
  warehouseNm: "",
  locationCd: "",
  stockQty: null,
};

/** API 응답 1건 → Info 패널 표시용 변환 */
export function toPDA1061_R01DisplayInfo(item: PDA1061_R01Dto): PDA1061_R01DisplayInfo {
  return {
    itemCd: (item.resultItemCd ?? item.itemCd) ?? "",
    itemNm: item.itemNm ?? "",
    itemSpec: item.itemSpec ?? "",
    modelNo: item.modelNo ?? "",
    unit: item.unit ?? "",
    itemStatus: item.itemStatus ?? "",
    warehouseNm: item.warehouseNm ?? "",
    locationCd: item.locationNm ?? item.locationCd ?? "",
    stockQty: item.stockQty ?? null,
  };
}
